export function initialize() {
	return () => {
		console.log('initialize');
	};
}
